export default {
  INIT_APP: (state, data) => {
    state.isAppLoaded = data
  }
}